import { createFileRoute } from '@tanstack/react-router'
import { requireCompleteProfile } from '@/lib/auth-guard'
import ArticleQuizResultsPage from '@/pages/ArticleQuizResults'
import { z } from 'zod'

export const Route = createFileRoute('/articles/quiz-results/$slug')({
  ...requireCompleteProfile(),
  validateSearch: z.object({
    summaryLevel: z.string().optional(),
  }),
  component: ArticleQuizResultsPage,
})